"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
/**
 * Returns true only if obj is a pure object (not null, neither Array nor Function nor Date).
 */
const isObject = (obj) => typeof obj === 'object' && typeof obj !== 'function' && !Array.isArray(obj) && obj !== null && !(obj instanceof Date);
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map